<div class="edit-screen" data-testid="edit-screen">
    <ntv-tabs
        [tabs]="tabs"
        [activeIndex]="activeTab()"
        (tabChange)="onTabChange($event)"></ntv-tabs>

    <div class="tab-content-container" data-testid="tab-content-container">
        <!-- Details Tab Content -->
        @if (activeTab() === 0) {
            <div class="tab-content" data-testid="tab-content">
                <app-details [hostData]="hostData()"></app-details>
            </div>
        }

        <!-- Hours Tab Content -->
        @if (activeTab() === 1) {
            <div class="tab-content" data-testid="tab-content">
                <app-hours></app-hours>
            </div>
        }
    </div>

    <div class="edit-screen__footer" data-testid="edit-screen-footer">
        <ntv-button variant="danger" size="xl" rounded="md" (buttonClick)="deleteClick.emit()">
            <div class="edit-screen__footer-btn-content">
                <svg width="14" height="14">
                    <use [attr.href]="spritePath + '#' + icons['outlineTrash']"></use>
                </svg>
                <span>Delete Host</span>
            </div>
        </ntv-button>

        <div class="edit-screen__footer-actions">
            <ntv-button
                size="xl"
                rounded="md"
                color="custom"
                customColor="#091635"
                (buttonClick)="cancelClick.emit()">
                Cancel
            </ntv-button>
            <ntv-button variant="accent" size="xl" rounded="md" (buttonClick)="updateClick.emit()">
                <div class="edit-screen__footer-btn-content">
                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#check'"></use>
                    </svg>
                    <span>Update</span>
                </div>
            </ntv-button>
        </div>
    </div>
</div>
